import { CalendarRange, ClipboardList, LayoutDashboard, User as UserIcon } from "lucide-react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

function Tab({ to, icon: Icon, label, testid }) {
    return (
        <NavLink
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
                cn(
                    "flex flex-1 flex-col items-center justify-center gap-1 py-2 text-[11px]",
                    isActive ? "text-brand-redDeep" : "text-zinc-500"
                )
            }
            data-testid={testid}
        >
            <Icon className="h-5 w-5" />
            <span className="font-medium">{label}</span>
        </NavLink>
    );
}

export function BottomNav() {
    return (
        <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t border-zinc-200 bg-white shadow-[0_-4px_18px_-12px_rgba(0,0,0,0.18)] dark:border-zinc-800 dark:bg-zinc-950">
            <Tab to="/" icon={LayoutDashboard} label="Home" testid="bottom-home" />
            <Tab to="/jobs" icon={ClipboardList} label="Jobs" testid="bottom-jobs" />
            <Tab to="/schedule" icon={CalendarRange} label="Schedule" testid="bottom-schedule" />
            <Tab to="/settings" icon={UserIcon} label="Me" testid="bottom-me" />
        </nav>
    );
}
